export default __webpack_public_path__ + "static/media/fruitinbox.1758dba4.jpg";